import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import api from '../../services/api';
import Modal from '../../comun/Modal';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { formatCurrency } from '../../utils/reportUtils';
import moment from 'moment';

const Empleados = () => {
    const { user } = useContext(AuthContext);
    const [empleados, setEmpleados] = useState([]);
    const [loading, setLoading] = useState(true);
    
    // Modal de Detalle
    const [selectedEmpleado, setSelectedEmpleado] = useState(null);
    const [showModal, setShowModal] = useState(false);
    
    // Filtros de fecha para el detalle (Por defecto, mes actual)
    const [dateFrom, setDateFrom] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [dateTo, setDateTo] = useState(moment().endOf('month').format('YYYY-MM-DD'));
    
    const [servicios, setServicios] = useState([]);
    const [loadingServicios, setLoadingServicios] = useState(false);

    useEffect(() => {
        fetchEmpleados();
    }, []);

    const fetchEmpleados = async () => {
        try {
            const res = await api.get('/api/users/by_role/?role=DOCTOR', {
                baseURL: process.env.REACT_APP_API_URL
            });
            setEmpleados(res.data.results || res.data || []);
        } catch (error) {
            console.error('Error fetching empleados:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchServiciosEmpleado = async (empleadoId, from, to) => {
        setLoadingServicios(true);
        try {
            // Utilizamos el endpoint de OrderItem que creamos
            const res = await api.get(`/api/orders/items/?doctor=${empleadoId}&date_from=${from}T00:00:00&date_to=${to}T23:59:59&payment_status=paid`, {
                baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE
            });
            setServicios(res.data.results || res.data || []);
        } catch (error) {
            console.error('Error fetching servicios:', error);
        } finally {
            setLoadingServicios(false);
        }
    };

    const handleViewDetalles = (empleado) => {
        setSelectedEmpleado(empleado);
        setShowModal(true);
        fetchServiciosEmpleado(empleado.id, dateFrom, dateTo);
    };

    const handleFilterSubmit = (e) => {
        e.preventDefault();
        if (selectedEmpleado) {
            fetchServiciosEmpleado(selectedEmpleado.id, dateFrom, dateTo);
        }
    };

    const exportToPDF = () => {
        if (!selectedEmpleado) return;
        
        const doc = new jsPDF();
        
        doc.setFontSize(18);
        doc.text(`Comisiones - ${selectedEmpleado.first_name} ${selectedEmpleado.last_name}`, 14, 22);
        
        doc.setFontSize(11);
        doc.text(`Periodo: ${moment(dateFrom).format('DD/MM/YYYY')} al ${moment(dateTo).format('DD/MM/YYYY')}`, 14, 30);
        
        const tableColumn = ["Fecha", "Servicio / Producto", "Orden", "Precio Un.", "Cant.", "Total"];
        const tableRows = [];
        
        let totalMensual = 0;
        
        servicios.forEach(s => {
            const date = moment(s.created_at).format('DD/MM/YYYY HH:mm');
            const name = s.product_details?.name || 'Servicio Médico';
            const orderNum = s.order_details?.order_number || 'N/A'; // Omitido si no tenemos el numero directo en el item
            const price = parseFloat(s.unit_price) || 0;
            const qty = s.quantity || 1;
            const total = parseFloat(s.line_total) || 0;
            
            totalMensual += total;
            
            tableRows.push([
                date,
                name,
                orderNum,
                formatCurrency(price),
                qty.toString(),
                formatCurrency(total)
            ]);
        });
        
        doc.autoTable({
            head: [tableColumn],
            body: tableRows,
            startY: 40,
            theme: 'grid',
            headStyles: { fillColor: [67, 56, 202] } // Indigo 700
        });
        
        const finalY = doc.lastAutoTable.finalY || 40;
        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');
        doc.text(`Total Generado: ${formatCurrency(totalMensual)}`, 14, finalY + 15);
        
        doc.save(`Comisiones_${selectedEmpleado.first_name}_${selectedEmpleado.last_name}_${moment().format('MMYYYY')}.pdf`);
    };

    return (
        <div className="page-container">
            <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2>Empleados</h2>
            </div>
            
            {loading ? (
                <div>Cargando empleados...</div>
            ) : empleados.length === 0 ? (
                <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280', background: 'white', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
                    No se encontraron empleados registrados con el rol de Doctor.
                </div>
            ) : (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
                    {empleados.map(empleado => (
                        <div key={empleado.id} style={{ 
                            background: 'white', 
                            borderRadius: '12px', 
                            padding: '24px', 
                            boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
                            border: '1px solid #e5e7eb',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            textAlign: 'center'
                        }}>
                            <div style={{ 
                                width: '80px', 
                                height: '80px', 
                                borderRadius: '50%', 
                                backgroundColor: '#e0e7ff',
                                color: '#4338ca',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '32px',
                                fontWeight: 'bold',
                                marginBottom: '16px'
                            }}>
                                {empleado.first_name ? empleado.first_name.charAt(0) : empleado.username.charAt(0)}
                            </div>
                            <h3 style={{ margin: '0 0 20px 0', fontSize: '18px', color: '#111827' }}>
                                {empleado.first_name} {empleado.last_name}
                            </h3>
                            
                            <button 
                                className="btn btn-primary"
                                style={{ width: '100%' }}
                                onClick={() => handleViewDetalles(empleado)}
                            >
                                Ver Detalles
                            </button>
                        </div>
                    ))}
                </div>
            )}

            {/* Modal de Detalles del Empleado */}
            {showModal && selectedEmpleado && (
                <Modal 
                    isOpen={true}
                    title={`Detalles de ventas de ${selectedEmpleado.first_name} ${selectedEmpleado.last_name}`} 
                    onClose={() => setShowModal(false)}
                    maxWidth="800px"
                >
                    <div style={{ padding: '20px' }}>
                        {/* Filtros */}
                        <form onSubmit={handleFilterSubmit} style={{ 
                            display: 'flex', 
                            flexWrap: 'wrap',
                            gap: '16px', 
                            alignItems: 'flex-end',
                            marginBottom: '24px',
                            background: '#f9fafb',
                            padding: '16px',
                            borderRadius: '8px',
                            border: '1px solid #e5e7eb'
                        }}>
                            <div>
                                <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', color: '#4b5563', marginBottom: '4px' }}>Desde:</label>
                                <input 
                                    type="date" 
                                    className="form-control" 
                                    value={dateFrom} 
                                    onChange={(e) => setDateFrom(e.target.value)} 
                                />
                            </div>
                            <div>
                                <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', color: '#4b5563', marginBottom: '4px' }}>Hasta:</label>
                                <input 
                                    type="date" 
                                    className="form-control" 
                                    value={dateTo} 
                                    onChange={(e) => setDateTo(e.target.value)} 
                                />
                            </div>
                            <button type="submit" className="btn btn-primary" style={{ height: '38px' }}>
                                Filtrar
                            </button>
                            <button type="button" className="btn btn-success" style={{ height: '38px', marginLeft: 'auto' }} onClick={exportToPDF}>
                                <i className="bi bi-file-pdf"></i> Exportar PDF
                            </button>
                        </form>

                        {/* Tabla de Resultados */}
                        {loadingServicios ? (
                            <div style={{ textAlign: 'center', padding: '40px' }}>Cargando servicios...</div>
                        ) : servicios.length === 0 ? (
                            <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
                                No se encontraron ventas para este empleado en el rango seleccionado.
                            </div>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead style={{ background: '#f3f4f6' }}>
                                        <tr>
                                            <th>Fecha</th>
                                            <th>Servicio / Producto</th>
                                            <th style={{ textAlign: 'right' }}>Precio Un.</th>
                                            <th style={{ textAlign: 'center' }}>Cant.</th>
                                            <th style={{ textAlign: 'right' }}>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {servicios.map(s => (
                                            <tr key={s.id}>
                                                <td>{moment(s.created_at).format('DD/MMM/YYYY HH:mm')}</td>
                                                <td>{s.product_details?.name || 'Desconocido'}</td>
                                                <td style={{ textAlign: 'right' }}>{formatCurrency(s.unit_price)}</td>
                                                <td style={{ textAlign: 'center' }}>{s.quantity}</td>
                                                <td style={{ textAlign: 'right', fontWeight: 'bold', color: '#10b981' }}>
                                                    {formatCurrency(s.line_total)}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr style={{ background: '#f9fafb', borderTop: '2px solid #e5e7eb' }}>
                                            <td colSpan="4" style={{ textAlign: 'right', fontWeight: 'bold', fontSize: '16px' }}>TOTAL GENERADO:</td>
                                            <td style={{ textAlign: 'right', fontWeight: 'bold', fontSize: '18px', color: '#4338ca' }}>
                                                {formatCurrency(servicios.reduce((acc, curr) => acc + parseFloat(curr.line_total || 0), 0))}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        )}
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default Empleados;
